import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dashboard: {},
  deliveryRequests: {},
  stockManagement: {},
  refreshList: false,
};

const taqabethEnforcerSlice = createSlice({
  name: "taqabeth",
  initialState,
  reducers: {
    addTaqabethEnforcer: (state, action) => {
      const { name, data } = action.payload;
      state[name] = data;
    },
    addRequestsManagement: (state, action) => {
      const { name, data } = action.payload;
      state[name] = data;
    },
    addDashboard: (state, action) => {
      const { data } = action.payload;
      state.dashboard = data;
    },
    isRefreshList: (state, action) => {
      state.refreshList = action.payload;
    },
  },
});

export default taqabethEnforcerSlice;
export const {
  addTaqabethEnforcer,
  addRequestsManagement,
  addDashboard,
  isRefreshList,
} = taqabethEnforcerSlice.actions;
